import { render, staticRenderFns } from "./USSDPayment.vue?vue&type=template&id=56db4077&scoped=true&"
import script from "./USSDPayment.vue?vue&type=script&lang=js&"
export * from "./USSDPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db4077",
  null
  
)

export default component.exports